import { useContext } from 'react';

import { AdminAuthContext, type AdminAuthContextValue } from './AdminAuthProvider';

export function useAdminAuth(): AdminAuthContextValue {
  const ctx = useContext(AdminAuthContext);
  if (ctx === null) {
    throw new Error('useAdminAuth must be used inside an <AdminAuthProvider>.');
  }
  return ctx;
}
